import React from "react"
import {unixToDate} from "../../_helpers/date"

const Date = ({date}) => (
    <div className="date-container">
        <span>{unixToDate(date)}</span>
    </div>
)
export default Date